// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__246n6","requiredAsterisk":"Info_requiredAsterisk__2EwyZ"};